import { snakeCaseToCamelCase } from "@/utils/formatters"
import type { CollectionProxy } from "spraypaint/lib-esm/proxies"

import type { ISitePreview, ISitePreviewDto } from "../../models/site"
import { Site } from "../../models/site"

export const sitePreviewResponseToFormattedData = (
  response: CollectionProxy<Site>
): ISitePreview[] => {
  const casedResponse = snakeCaseToCamelCase(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    response.meta.stats.site_preview.map
  ) as ISitePreviewDto[]

  return casedResponse
    .sort((siteNavItemA, siteNavItemB) =>
      siteNavItemA.siteName.localeCompare(siteNavItemB.siteName)
    )
    .map(
      (siteNavItem: ISitePreviewDto): ISitePreview => ({
        departmentName: siteNavItem.departmentName,
        id: siteNavItem.siteId.toString(),
        name: siteNavItem.siteName,
        electricityType: siteNavItem.electricityType,
        timezone: siteNavItem.timezone,
        topOrgUnitName: siteNavItem.topOrgUnitName,
      })
    )
}

export const fetchSitePreviewsByOrgId = ({
  orgId,
}: {
  orgId: string
}): Promise<ISitePreview[]> =>
  Site.where({
    organization_id: orgId,
  })
    .stats({ site_preview: "map" })
    .per(0)
    .all()
    .then(sitePreviewResponseToFormattedData)
